import { render, staticRenderFns } from "./LikeProfile.vue?vue&type=template&id=f7697520&"
import script from "./LikeProfile.vue?vue&type=script&lang=js&"
export * from "./LikeProfile.vue?vue&type=script&lang=js&"
import style0 from "./LikeProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports